import React, { useEffect } from 'react';
import { useNotificationStore } from '../state/notifications';
import { DEBUG } from '../utils/debug';

const InAppNotification: React.FC = () => {
  if (DEBUG) {
    // logging removed
  }


  useEffect(() => {
    if (DEBUG) {
      // logging removed
    }

    function handleSWMessage(event: MessageEvent) {
      if (DEBUG) {
        // logging removed
      }

      if (
        event.data &&
        event.data.type === 'IN_APP_NOTIFICATION' &&
        event.data.payload
      ) {
        if (DEBUG) {
          // logging removed
        }
        useNotificationStore.getState().addNotification({
          ...event.data.payload,
          id:
            event.data.payload.id ||
            (window.crypto && 'randomUUID' in window.crypto
              ? window.crypto.randomUUID()
              : Date.now().toString()),
          read: false,
        });
        if (DEBUG) {
          // logging removed
        }
      }
    }

    window.addEventListener('message', handleSWMessage);

    if ('serviceWorker' in navigator && navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', handleSWMessage);
    }

    return () => {
      window.removeEventListener('message', handleSWMessage);
      if ('serviceWorker' in navigator && navigator.serviceWorker) {
        navigator.serviceWorker.removeEventListener('message', handleSWMessage);
      }
    };
  }, []);

  return null; // ToastContainer should be in App.tsx
};

export default InAppNotification;
